/* Mediheal PDP sticky bar: thumbnail + name + price + ADD TO CART. */
(function () {
  if (window.__mhPdpSticky) return;
  window.__mhPdpSticky = true;

  var css =
    '#mh-pdp-sticky[hidden]{display:none!important}' +
    '#mh-pdp-sticky{position:fixed;left:0;right:0;bottom:0;z-index:2147482500;' +
      'display:flex;align-items:center;justify-content:space-between;gap:16px;' +
      'padding:10px 24px calc(10px + env(safe-area-inset-bottom));' +
      'background:#fff;box-shadow:0 -4px 24px rgba(0,0,0,.08);font-family:inherit}' +
    '#mh-pdp-sticky .mh-pdp-left{min-width:0;flex:1;display:flex;align-items:center;gap:12px}' +
    '#mh-pdp-sticky .mh-pdp-thumb{width:44px;height:44px;object-fit:contain;flex:0 0 44px;background:#f6f6f6}' +
    '#mh-pdp-sticky .mh-pdp-copy{min-width:0;display:flex;flex-direction:column;gap:2px}' +
    '#mh-pdp-sticky .mh-pdp-title{margin:0;font-size:13px;font-weight:600;color:#111;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '#mh-pdp-sticky .mh-pdp-meta{margin:0;font-size:12px;font-weight:500;color:#666;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '#mh-pdp-sticky button{flex:0 0 auto;appearance:none;cursor:pointer;min-width:220px;' +
      'padding:16px 36px;font-size:15px;font-weight:600;letter-spacing:.04em;text-transform:uppercase}' +
    '@media (max-width:749px){' +
      '#mh-pdp-sticky{padding:8px 12px calc(8px + env(safe-area-inset-bottom));gap:10px}' +
      '#mh-pdp-sticky .mh-pdp-thumb{width:40px;height:40px;flex-basis:40px}' +
      '#mh-pdp-sticky .mh-pdp-title{font-size:12px}' +
      '#mh-pdp-sticky .mh-pdp-meta{font-size:11px}' +
      '#mh-pdp-sticky button{min-width:140px;padding:13px 18px;font-size:13px}' +
    '}';

  var style = document.createElement('style');
  style.setAttribute('data-mh-pdp-sticky', '1');
  style.textContent = css;
  document.head.appendChild(style);

  function text(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function findAtc() {
    return document.querySelector(
      '.ecom-product-single__add-to-cart--submit,' +
      '.ecom-product-form button[name="add"],' +
      '.ecom-product-form button[type="submit"],' +
      'button.product-form__submit[name="add"]'
    );
  }

  function findTitle() {
    return document.querySelector(
      '.ecom-product-single__title,' +
      'h1.product__title, .product__title, h1'
    );
  }

  function priceEl() {
    return document.querySelector('.ecom-product-single__price--sale') ||
      document.querySelector('.ecom-product-single__price--regular') ||
      document.querySelector('.price-item--sale') ||
      document.querySelector('.price-item--regular');
  }

  function currentPrice() {
    var raw = text(priceEl());
    var m = raw && raw.match(/\$[\d,]+(?:\.\d{2})?/);
    return m ? m[0] : '';
  }

  function findVariant() {
    var selected = document.querySelector(
      '.ecom-product-single__variant-picker .ecom-item-active,' +
      '.ecom-product-single__variant-picker [aria-checked="true"],' +
      '.ecom-product-single__variant-picker .active,' +
      '.product-form__input input:checked + label'
    );
    return text(selected);
  }

  function findImageSrc() {
    var img = document.querySelector(
      '.ecom-product-gallery img, .ecom-product-single__media img,' +
      '.ecom-slider img, .product__media img, .product-media img'
    );
    if (img) return img.currentSrc || img.src || '';
    var og = document.querySelector('meta[property="og:image"]');
    return og ? og.getAttribute('content') : '';
  }

  function isProductPage() {
    return document.body.classList.contains('template-product') ||
      !!document.querySelector('.ecom-product-form, .ecom-product-single__add-to-cart--submit, button.product-form__submit[name="add"]');
  }

  function metaLine(variant, price) {
    if (variant && price) return variant + '  ·  ' + price;
    return variant || price || '';
  }

  function mount(atc) {
    if (document.getElementById('mh-pdp-sticky')) return;

    var titleEl = findTitle();
    var title = text(titleEl) || document.title.split('–')[0].trim();
    var price = currentPrice();
    var variant = findVariant();
    var src = findImageSrc();

    var bar = document.createElement('div');
    bar.id = 'mh-pdp-sticky';
    bar.hidden = true;
    bar.innerHTML =
      '<div class="mh-pdp-left">' +
        (src ? '<img class="mh-pdp-thumb" alt="">' : '') +
        '<div class="mh-pdp-copy">' +
          '<div class="mh-pdp-title"></div>' +
          '<div class="mh-pdp-meta"></div>' +
        '</div>' +
      '</div>';
    bar.querySelector('.mh-pdp-title').textContent = title;
    bar.querySelector('.mh-pdp-meta').textContent = metaLine(variant, price);
    var thumb = bar.querySelector('.mh-pdp-thumb');
    if (thumb) thumb.src = src;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = text(atc) || 'ADD TO CART';
    var cs = window.getComputedStyle(atc);
    btn.style.backgroundColor = cs.backgroundColor;
    btn.style.color = cs.color;
    btn.style.fontFamily = cs.fontFamily;
    btn.style.fontWeight = cs.fontWeight;
    btn.style.letterSpacing = cs.letterSpacing;
    btn.style.textTransform = cs.textTransform;
    btn.style.border = cs.border;
    btn.style.borderRadius = cs.borderRadius || '4px';
    btn.addEventListener('click', function () { atc.click(); });
    bar.appendChild(btn);
    document.body.appendChild(bar);

    function refresh() {
      var nextPrice = currentPrice();
      var nextVar = findVariant();
      var nextSrc = findImageSrc();
      bar.querySelector('.mh-pdp-meta').textContent = metaLine(nextVar, nextPrice);
      if (thumb && nextSrc) thumb.src = nextSrc;
    }
    var watch = priceEl() || document.querySelector('.ecom-product-form, .ecom-product-single__variant-picker');
    if (watch && window.MutationObserver) {
      new MutationObserver(refresh).observe(watch, { childList: true, subtree: true, attributes: true, characterData: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.ecom-product-single__variant-picker, .product-form__input')) {
        setTimeout(refresh, 80);
      }
    });

    if (typeof IntersectionObserver === 'undefined') {
      bar.hidden = false;
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    io.observe(atc);
  }

  function boot() {
    if (!isProductPage()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var atc = findAtc();
      if (atc) {
        clearInterval(timer);
        mount(atc);
      } else if (tries >= 20) {
        clearInterval(timer);
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
